import { createDecorator } from '../../instantiation/common/instantiation.js';
const IRemoteAuthorityResolverService = ( createDecorator('remoteAuthorityResolverService'));
export { IRemoteAuthorityResolverService };
